import { isEmpty } from '@ember/utils';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';
import { JurisdictionalIdValidations } from 'linced-app/utils/fields';
import moment from 'moment';

const jurisdictionalIdValidator =
  JurisdictionalIdValidations[Jurisdiction.NZ_MOE];

export function validateCoreDetails(person, enrolment, schoolType) {
  let errors = [];
  if (!jurisdictionalIdValidator(person.jurisdictionalId)) {
    errors.push('No valid NSN found');
  }
  if (isEmpty(person.gender) || person.gender === 'N') {
    errors.push('Gender is not set');
  }
  if (isEmpty(person.dob) || person.dob <= '1970-01-01') {
    errors.push('Date of Birth is not set');
  }
  if (moment(person.dob, 'YYYY-MM-DD').isSameOrAfter(moment(), 'day')) {
    errors.push('Date of Birth must be in the past');
  }
  if (!validateYearLevel(person.get('currentYearLevel') ?? 0, schoolType)) {
    errors.push(
      "Current Year Level is invalid (not allowed for this school's type)",
    );
  }

  return errors;
}

export function validateYearLevel(yearLevel, schoolType) {
  let min = 0,
    max = 13;
  switch (schoolType) {
    case 20: // Full Primary
      min = 0;
      max = 8;
      break;
    case 21: // Contributing Primary
      min = 0;
      max = 6;
      break;
    case 22: // Intermediate
      min = 7;
      max = 8;
      break;
    case 23: // Special
      min = 0;
      max = 13;
      break;
    case 30: // Secondary (7-13)
      min = 7;
      max = 13;
      break;
    case 32: // Composite
      min = 0;
      max = 13;
      break;
    case 34: // Correspondence
      min = 0;
      max = 13;
      break;
    case 35: // Restricted composite
      min = 7;
      max = 10;
      break;
    case 40: // Secondary (9-15)
    case 41: // Teen Parent Unit
      min = 9;
      max = 13;
      break;
  }

  return yearLevel >= min && yearLevel <= max;
}
